export default "__VITE_ASSET__LtUUEsjN__"